import type {
  Event as UserEvent,
  Entry as UserEntry,
} from "@tandemdiabetes/sugarmate-api-react-client"
import type { MangoQuery } from "rxdb"
import type { SharedProperties } from "src/types"

const defaultSelector = {}
const defaultSort = [{ started_at: "desc" as const }]

type UserItem = SharedProperties<UserEvent, UserEntry>

// adds "deleted_at" selector to event or entry query
export function createQueryObject(
  accountId: number,
  {
    selector,
    sort,
    limit,
  }: MangoQuery<UserItem>,
): MangoQuery<UserItem> {
  return {
    selector: {
      account_id: { $eq: accountId },
      deleted_at: { $eq: null },
      ...(selector ?? defaultSelector),
    },
    sort: (sort ?? defaultSort),
    limit,
  }
}
